import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import API_BASE_URL from "../config";
import { vmPageShell } from "./vehicleManagementLayout";

const DieselConfirmation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { formData } = location.state || {};

  if (!formData) {
    return (
      <div style={{ ...vmPageShell(false, { marginRightPx: 10 }), padding: "40px", fontSize: "14px" }}>
        No data.
      </div>
    );
  }

  const styles = {
    container: {
      ...vmPageShell(false, { marginRightPx: 10 }),
      fontFamily: "Arial, sans-serif",
      backgroundColor: "white",
      color: "black",
      minHeight: "calc(100vh - 70px)",
      boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
    },
    pageHeader: {
      backgroundColor: "#FFC107",
      color: "#000",
      padding: "16px 20px",
      fontWeight: "bold",
      fontSize: "22px",
      letterSpacing: "1px",
      textTransform: "uppercase",
    },
    formWrapper: {
      padding: "24px 20px",
    },
    sectionTitle: {
      fontWeight: "bold",
      fontSize: "15px",
      color: "#000",
      borderBottom: "2px solid #FFC107",
      paddingBottom: "6px",
      marginBottom: "16px",
    },
    formGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
      gap: "20px",
      marginBottom: "24px",
    },
    label: {
      fontWeight: "bold",
      fontSize: "14px",
      marginBottom: "6px",
      display: "block",
      color: "#000",
    },
    input: {
      width: "100%",
      padding: "9px 10px",
      border: "1.5px solid #000",
      borderRadius: "4px",
      fontSize: "14px",
      boxSizing: "border-box",
      color: "#000",
      backgroundColor: "#f9f9f9",
      outline: "none",
    },
    buttonRow: {
      display: "flex",
      gap: "12px",
      justifyContent: "flex-end",
      paddingBottom: "10px",
    },
    btnBlack: {
      padding: "9px 28px",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      backgroundColor: "black",
      color: "white",
      fontWeight: "bold",
      fontSize: "14px",
    },
    btnYellow: {
      padding: "9px 28px",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      backgroundColor: "#FFC107",
      color: "black",
      fontWeight: "bold",
      fontSize: "14px",
    },
  };

  const handleSubmit = async () => {
    try {
      const response = await axios.post(API_BASE_URL + "/vehicle/diesel", formData);
      console.log("Submission successful:", response.data);
      alert("Diesel details submitted successfully!");
      navigate("/diesel");
    } catch (error) {
      console.error("Error submitting diesel details:", error);
      alert("Failed to submit diesel details. Please try again.");
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.pageHeader}>DIESEL CONFIRMATION</div>

      <div style={styles.formWrapper}>
        <div style={styles.sectionTitle}>Review</div>

        <div style={styles.formGrid}>
          {Object.keys(formData).map((key) => (
            <div key={key}>
              <label style={styles.label}>
                {key.replace(/([A-Z])/g, " $1").trim()}:
              </label>
              {key === "dieselSlipPhoto" &&
              typeof formData[key] === "string" &&
              formData[key].startsWith("data:image") ? (
                <img
                  src={formData[key]}
                  alt="Diesel slip"
                  style={{ maxWidth: "100%", maxHeight: 220, border: "1px solid #ccc", borderRadius: 4 }}
                />
              ) : (
                <input
                  type="text"
                  style={styles.input}
                  value={formData[key]}
                  readOnly
                />
              )}
            </div>
          ))}
        </div>

        <div style={styles.buttonRow}>
          <button style={styles.btnBlack} onClick={() => navigate(-1)}>
            Back
          </button>
          <button style={styles.btnYellow} onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default DieselConfirmation;